import React, { useEffect, useRef, useState } from "react";

type PropsType = {
    rootid: string;
    unit: string;
    width: number;
    height: number;
    marginStyle?: string;
    refreshKey: string; // 리렌더/리마운트 트리거 전용 키(부모에서 URL 기반 등으로 관리)
}

const KakaoAdfit = ({
    rootid,
    unit,
    width,
    height,
    marginStyle = "",
    refreshKey = ""
}: PropsType) => {

    const [hasAd, setHasAd] = useState(false); // 광고 표시 여부

    const scriptElementWrapper = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const wrap = scriptElementWrapper.current;
        if (!wrap) return;

        setHasAd(false);

        // (선택) 이전 것 정리
        wrap.querySelectorAll("script[src*='t1.kakaocdn.net/kas/static/ba.min.js']").forEach(s => s.remove());

        const script = document.createElement("script");
        script.src = "https://t1.kakaocdn.net/kas/static/ba.min.js";
        script.async = true;
        wrap.appendChild(script);
    }, [refreshKey]); // URL이 바뀌면 다시 주입

    // 광고 표시 여부 감지: iframe 생성/높이 변화 체크
    useEffect(() => {
        const wrap = scriptElementWrapper.current;
        if (!wrap) return;

        const check = () => {
            const shown = wrap.offsetHeight > 0 || !!wrap.querySelector("iframe");
            setHasAd(shown);
        };

        // 높이 변화 감지
        let ro: ResizeObserver | null = null;
        if (typeof window !== "undefined" && "ResizeObserver" in window) {
            ro = new ResizeObserver(() => check());
            ro.observe(wrap);
        }

        // DOM 변화 감지(iframe 추가 등)
        const mo = new MutationObserver(() => check());
        mo.observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class"] });

        // 초기 1회
        check();

        return () => {
            mo.disconnect();
            ro?.disconnect();
        };
    }, [refreshKey]);

    // 로컬 일 경우 광고 송출 안 되기도하고, 디버깅할 때 버벅거려서 숨김
    return window.location.hostname === "localhost" ? <></> :
        <div id={rootid}
            ref={scriptElementWrapper}
            style={{ width: "100%", textAlign: "center" }}
            key={refreshKey}
        >
            <ins className="kakao_ad_area"
                // 광고가 보일 때만 여백 적용
                style={{ display: "none", margin: hasAd ? (marginStyle || 0) : 0 }}
                data-ad-unit={unit}
                data-ad-width={width}
                data-ad-height={height}></ins>
        </div>
        ;
}

// routeKey 값이 안 바뀌면 리렌더 스킵
export default React.memo(KakaoAdfit, (prev, next) => {
  return prev.refreshKey === next.refreshKey;
});